import { Dialog } from '@progress/kendo-react-dialogs';
import { ic_nav_back as BackIcon } from 'app/widgets/SVGs';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { IEquipmentEntry } from 'types/IEquipmentEntry';
import { EquipmentDetails } from '../../EquipmentDetailsBox';
import * as utils from '../../maintenanceUtils';
import { MaintenanceIntervalCard } from './MaintenanceIntervalCard';
import useMaintenanceNextIntervals from './useMaintenanceNextIntervals';

interface IProps {
  isVisible: boolean;
  setVisible: any;
  equipmentDetails: IEquipmentEntry;
  openEngineHoursUpdateDialog: boolean;
  setOpenEngineHoursUpdateDialog: any;
}

export function NewMaintenanceDialog(props: IProps) {
  const { t } = useTranslation();

  const engineHours = utils.getCurrentEngineHours(props.equipmentDetails) ?? 0;
  const intervals = useMaintenanceNextIntervals(engineHours);

  const [visibleDialog, setVisibleDialog] = React.useState(false);

  const toggleDialog = () => props.setVisible(!props.isVisible);

  return (
    <Dialog className="modal-form">
      <div className="modal-container relative">
        <span className="back-button absolute" onClick={toggleDialog}>
          <BackIcon />
        </span>
        <div>
          {props.equipmentDetails.nickName || props.equipmentDetails.model}
        </div>
        <h1>{t('maintenance_history_track')}</h1>
        <EquipmentDetails
          eqipmentDetails={props.equipmentDetails}
          openEngineHoursUpdateDialog={props.openEngineHoursUpdateDialog}
          setOpenEngineHoursUpdateDialog={props.setOpenEngineHoursUpdateDialog}
        />
        <h3 className="info-panel-list-header">
          {t('maintenance_select_interval')}
        </h3>
        <div className="info-panel-list">
          <div className="info-panel-list-items scroll-area">
            {intervals?.map((maintenanceInterval, index) => (
              <MaintenanceIntervalCard
                maintenanceInterval={maintenanceInterval}
                index={index}
                key={index}
                visible={visibleDialog}
                setVisible={setVisibleDialog}
                closeTrackMaintenanceDialog={toggleDialog}
                openEngineHoursUpdateDialog={props.openEngineHoursUpdateDialog}
                setOpenEngineHoursUpdateDialog={
                  props.setOpenEngineHoursUpdateDialog
                }
              />
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  );
}
